var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M866.07,515.3Q840.9,531,818,547.2t-47.17,34.59q-24.26,18.42-55.7,41.77L709.74,620q1.78-10.79,11.68-26.5t23.36-33.69q13.47-18,29.65-36.39t31.44-34.59H472.55L319.81,606.5H287.47L440.2,487.9H413.25L259.62,606.5H226.37L380,487.9H352.16L198.52,606.5H165.28L318.91,487.9H291.06L137.43,606.5H105.08L260.52,487.9H236.26V471.73h24.26L105.08,353.13h32.35l153.63,118.6h27.85L165.28,353.13h33.24l153.64,118.6H380L226.37,353.13h33.25l153.63,118.6H440.2L287.47,353.13h32.34l152.74,117.7H805.87q-15.29-16.17-31.44-35T744.78,398.5q-13.49-18.39-23.36-34.14t-11.68-26.5l5.39-3.6q28.74,22.47,51.66,40t45.82,33.69q22.9,16.17,49.42,32.34t61.54,36.84v3.59Q891.23,499.58,866.07,515.3Z","transform":"translate(-105.08 -334.26)"}));
}

Arrow.defaultProps = {"viewBox":"0 0 818.48 289.3"};

module.exports = Arrow;

Arrow.default = Arrow;
